module.exports = __webpack_public_path__ + "img/choose-your-mood.9e8fe96c.svg";